import { render } from "./EjwPolicy.vue?vue&type=template&id=934238cc&scoped=true"
import script from "./EjwPolicy.vue?vue&type=script&lang=js"
export * from "./EjwPolicy.vue?vue&type=script&lang=js"

import "./EjwPolicy.vue?vue&type=style&index=0&id=934238cc&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-934238cc"]])

export default __exports__